(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- header: mega panels ---------- */
  var hdr = $('#siteHeader');
  var overlay = $('#ghOverlay');
  function closeAll() {
    if (!hdr) return;
    $$('[data-gh-panel]', hdr).forEach(function (p) { p.classList.remove('open'); });
    $$('[data-gh-toggle]', hdr).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    hdr.classList.remove('menu-open');
    if (overlay) overlay.classList.remove('show');
  }
  function openPanel(id) {
    var panel = document.getElementById(id);
    if (!panel) return;
    var wasOpen = panel.classList.contains('open');
    closeAll();
    if (wasOpen) return;
    panel.classList.add('open');
    var btn = $('[data-gh-toggle="' + id + '"]', hdr);
    if (btn) btn.setAttribute('aria-expanded', 'true');
    hdr.classList.add('menu-open');
    if (overlay) overlay.classList.add('show');
  }
  if (hdr) {
    $$('[data-gh-toggle]', hdr).forEach(function (b) {
      b.addEventListener('click', function (e) { e.stopPropagation(); openPanel(b.getAttribute('data-gh-toggle')); });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.gh-shell')) closeAll(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    if (overlay) overlay.addEventListener('click', closeAll);
    var onScroll = function () { hdr.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- scroll reveal ---------- */
  var rev = $$('[data-reveal],[data-reveal-lines]');
  if ('IntersectionObserver' in window && rev.length && document.visibilityState === 'visible') {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    rev.forEach(function (el) { io.observe(el); });
  } else {
    rev.forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- description tables: label cells so they stack on phones ---------- */
  $$('.rte table').forEach(function (t) {
    var hs = $$('thead th', t).map(function (th) { return th.textContent.trim(); });
    if (!hs.length) return;
    t.classList.add('gl-stack');
    $$('tbody tr', t).forEach(function (tr) {
      $$('td', tr).forEach(function (td, k) { td.setAttribute('data-label', hs[k] || ''); });
    });
  });

  /* ---------- reviews: single-card carousel ---------- */
  $$('[data-gl-rv]').forEach(function (root) {
    var track = $('.gl-rv-track', root);
    var slides = $$('.gl-rv-slide', root);
    var dotsBox = $('.gl-rv-dots', root);
    if (!track || !slides.length) return;
    var i = 0, timer = null;
    slides.forEach(function (_, k) {
      var d = document.createElement('button');
      d.type = 'button';
      d.setAttribute('aria-label', 'Show review ' + (k + 1));
      d.addEventListener('click', function () { go(k); restart(); });
      dotsBox && dotsBox.appendChild(d);
    });
    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      $$('button', dotsBox).forEach(function (d, k) { d.classList.toggle('on', k === i); });
    }
    function restart() { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, 6000); }
    var prev = $('.gl-rv-arrow.prev', root), next = $('.gl-rv-arrow.next', root);
    prev && prev.addEventListener('click', function () { go(i - 1); restart(); });
    next && next.addEventListener('click', function () { go(i + 1); restart(); });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    var sx = null;
    root.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); restart(); }
      sx = null;
    });
    go(0); restart();
  });
})();
